import React, { useState, createContext, useContext } from 'react';
interface ClientContextType {
  clientName: string;
  setClientName: (name: string) => void;
  companyName: string;
  setCompanyName: (name: string) => void;
}
// Updated default values in createContext to reflect new initial state
const ClientContext = createContext<ClientContextType>({
  clientName: 'Andy Chatham',
  setClientName: () => {},
  companyName: 'NPP Neuro Group',
  setCompanyName: () => {}
});
export function ClientProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [clientName, setClientName] = useState('Andy Chatham');
  const [companyName, setCompanyName] = useState('NPP Neuro Group');
  return <ClientContext.Provider value={{
    clientName,
    setClientName,
    companyName,
    setCompanyName
  }} data-id="element-36">
      {children}
    </ClientContext.Provider>;
}
export function useClient() {
  return useContext(ClientContext);
}